import { formatWeekIdentifierInt } from '../order/capacityplannerproducttypes';
import { flatten } from 'lodash';

export function buildCapacityByPortfolioAndWeekData(capacityAllocationsByWeek, portfolios, weekList, changes) {
    let returnValue = {
        capacityPerPortfolio: {},
        urgentCapacity: {},
    };

    const capacityAllocations = flatten(
        Object.keys(capacityAllocationsByWeek).map((k) => capacityAllocationsByWeek[k])
    );
    if (portfolios && portfolios.length > 0 && capacityAllocations) {
        for (const p of portfolios.filter((p) => p.id !== 0)) {
            let capaPerPortfolio = {
                portfolioId: p.id,
                capacities: Object.fromEntries(
                    capacityAllocations
                        .filter((a) => a.portfolioId === p.id)
                        .map((a) => {
                            const key = formatWeekIdentifierInt(a.year, a.week);
                            return [key, a.allocatedCapacity];
                        })
                ),
            };
            for (const w of weekList) {
                if (typeof capaPerPortfolio.capacities[w] === 'undefined') {
                    capaPerPortfolio.capacities[w] = 0;
                }
            }
            returnValue.capacityPerPortfolio[p.id] = capaPerPortfolio;
        }
        returnValue.urgentCapacity = Object.fromEntries(
            capacityAllocations
                .filter((a) => a.portfolioId === 0)
                .map((a) => {
                    const key = formatWeekIdentifierInt(a.year, a.week);
                    return [key, a.allocatedCapacity];
                })
        );
    }

    // retain already modified values if given
    if (changes && changes.length > 0) {
        for (const c of changes) {
            if (c.portfolioId > 0) {
                returnValue.capacityPerPortfolio[c.portfolioId].capacities[formatWeekIdentifierInt(c.year, c.week)] =
                    c.allocatedCapacity;
            } else {
                returnValue.urgentCapacity[formatWeekIdentifierInt(c.year, c.week)] = c.allocatedCapacity;
            }
        }
    }
    return returnValue;
}

export function buildCapacityByCapacityGroupAndWeekData(capacityAllocationsByWeek, capacityGroups, weekList, changes) {
    let returnValue = {
        capacityPerCapacityGroup: {},
    };

    const capacityAllocations = flatten(
        Object.keys(capacityAllocationsByWeek).map((k) => capacityAllocationsByWeek[k])
    );
    if (capacityGroups && capacityGroups.length > 0 && capacityAllocations) {
        for (const capacityGroup of capacityGroups) {
            let capacityPerGroup = {
                capacityGroupId: capacityGroup.id,
                capacities: Object.fromEntries(
                    capacityAllocations
                        .filter((a) => a.capacityGroup.id === capacityGroup.id)
                        .map((a) => {
                            const key = formatWeekIdentifierInt(a.year, a.week);
                            return [key, a.allocatedCapacity];
                        })
                ),
            };
            for (const w of weekList) {
                if (typeof capacityPerGroup.capacities[w] === 'undefined') {
                    capacityPerGroup.capacities[w] = 0;
                }
            }
            returnValue.capacityPerCapacityGroup[capacityGroup.id] = capacityPerGroup;
        }
    }

    // retain already modified values if given
    if (changes && changes.length > 0) {
        for (const c of changes) {
            returnValue.capacityPerCapacityGroup[c.capacityGroup.id].capacities[
                formatWeekIdentifierInt(c.year, c.week)
            ] = c.allocatedCapacity;
        }
    }
    return returnValue;
}
